import { render, staticRenderFns } from "./Waiver.vue?vue&type=template&id=3178a5b0"
import script from "./Waiver.vue?vue&type=script&lang=js"
export * from "./Waiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports